import { memo } from 'react';
import { Badge, Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { PERMISSION_SOURCE_META } from '../../constants/copy';

/**
 * Permission source tag: via <Role>, Direct, Pinned or Modified, with a tooltip that explains
 * where the access comes from.
 *
 * @param {object} props
 * @param {'viaRole'|'direct'|'pinned'|'modified'} props.source
 * @param {string} [props.roleName] Role name from the API (for `viaRole`).
 */
const PermissionSourceTag = ({ source, roleName }) => {
  const { t } = useTranslation('people-access');
  const meta = PERMISSION_SOURCE_META[source];

  if (!meta) return null;

  return (
    <Tooltip size="compact" content={t(`terms.sourceHint.${source}`, { role: roleName })}>
      <Badge size="small" variant={meta.variant}>
        {t(meta.labelKey, { role: roleName })}
      </Badge>
    </Tooltip>
  );
};

export default memo(PermissionSourceTag);
